export default function no_auth_exportProductListingData() {
  return {
    'PartNumber': 'PartNumber',
    'Datasheet': 'Datasheet',
    'Manufacturer': 'Manufacturer',
    'ProductDescription': 'ProductDescription',
    'Availability': 'Stock (Availability)',
    'Lead time': 'Lead Time'
  }
};